import { css } from 'twin.macro';
import React from 'react';
import { FacebookCounter } from '@charkour/react-reactions';

const ReactionCounters = ({ id, reactionCounter = [], showMessageReactions, currUser, isSenderMessage = false }) => {
    return (
        <div
            css={css`
                visibility: ${reactionCounter.length ? 'visible' : 'hidden'};
                display: flex;
                justify-content: ${isSenderMessage ? 'flex-end' : 'flex-start'};
                z-index: 10;
                > div {
                    align-items: center;
                    background: white;
                    border: 1px solid #d8d8d8;
                    padding: 0 0.5rem;
                    border-radius: 50px;
                    bottom: ${isSenderMessage ? '-0.6rem' : '-1.2rem'};
                    position: absolute;
                    ${isSenderMessage ? 'width: max-content !important;' : ''}
                }
            `}
            onClick={() => showMessageReactions(id)}
        >
            <FacebookCounter user={currUser?.name} counters={reactionCounter} />
        </div>
    );
};

export default ReactionCounters;
